{
  "api/v1/customer/room-objects": {
    "response": [
      {
        "id": 35001,
        "address_id": "ADDRESS_ID_1",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-05-12",
        "description": null,
        "name": "Smart TV",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7001,
          "name": "Smart TV",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 248,
            "name": "Smart TV",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1",
          "add_state": "ADDRESS_STATE_1",
          "zip": "ADDRESS_ZIP_1",
          "state": "active",
          "address_name": "ADDRESS_NAME_1"
        }
      },
      {
        "id": 35002,
        "address_id": "ADDRESS_ID_1",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-05-12",
        "description": null,
        "name": "Refrigerator",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7002,
          "name": "Refrigerator",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 413,
            "name": "Refrigerator",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/refrigerator (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1",
          "add_state": "ADDRESS_STATE_1",
          "zip": "ADDRESS_ZIP_1",
          "state": "active",
          "address_name": "ADDRESS_NAME_1"
        }
      },
      {
        "id": 35003,
        "address_id": "ADDRESS_ID_1",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-05-12",
        "description": null,
        "name": "Microwave",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7003,
          "name": "Microwave",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 428,
            "name": "Microwave",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/microwave.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1",
          "add_state": "ADDRESS_STATE_1",
          "zip": "ADDRESS_ZIP_1",
          "state": "active",
          "address_name": "ADDRESS_NAME_1"
        }
      },
      {
        "id": 35004,
        "address_id": "ADDRESS_ID_1",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-05-12",
        "description": null,
        "name": "Coffee Maker",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7004,
          "name": "Coffee Maker",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 516,
            "name": "Coffee Maker",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/coffee-pot (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1",
          "add_state": "ADDRESS_STATE_1",
          "zip": "ADDRESS_ZIP_1",
          "state": "active",
          "address_name": "ADDRESS_NAME_1"
        }
      },
      {
        "id": 35005,
        "address_id": "ADDRESS_ID_1",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-05-12",
        "description": null,
        "name": "Air Conditioner",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7005,
          "name": "Air Conditioner",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 414,
            "name": "Air Conditioner",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/air-conditioner.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1",
          "add_state": "ADDRESS_STATE_1",
          "zip": "ADDRESS_ZIP_1",
          "state": "active",
          "address_name": "ADDRESS_NAME_1"
        }
      },
      {
        "id": 35006,
        "address_id": "ADDRESS_ID_1",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-05-12",
        "description": null,
        "name": "Washer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7006,
          "name": "Washer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 432,
            "name": "Washer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/washing-machine.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1",
          "add_state": "ADDRESS_STATE_1",
          "zip": "ADDRESS_ZIP_1",
          "state": "active",
          "address_name": "ADDRESS_NAME_1"
        }
      },
      {
        "id": 35007,
        "address_id": "ADDRESS_ID_1",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-05-12",
        "description": null,
        "name": "Dryer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7007,
          "name": "Dryer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 433,
            "name": "Dryer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/dryer.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1",
          "add_state": "ADDRESS_STATE_1",
          "zip": "ADDRESS_ZIP_1",
          "state": "active",
          "address_name": "ADDRESS_NAME_1"
        }
      },
      {
        "id": 35008,
        "address_id": "ADDRESS_ID_1",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-05-12",
        "description": null,
        "name": "Oven",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7008,
          "name": "Oven",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 430,
            "name": "Oven",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/oven.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1",
          "add_state": "ADDRESS_STATE_1",
          "zip": "ADDRESS_ZIP_1",
          "state": "active",
          "address_name": "ADDRESS_NAME_1"
        }
      },
      {
        "id": 35009,
        "address_id": "ADDRESS_ID_1",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-05-12",
        "description": null,
        "name": "Stove",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7009,
          "name": "Stove",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 431,
            "name": "Stove",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/stove.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1",
          "add_state": "ADDRESS_STATE_1",
          "zip": "ADDRESS_ZIP_1",
          "state": "active",
          "address_name": "ADDRESS_NAME_1"
        }
      },
      {
        "id": 36001,
        "address_id": "ADDRESS_ID_1",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Toilet Paper",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1800,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7010,
          "name": "Toilet Paper",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 501,
            "name": "Toilet Paper",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/toilet-paper.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1",
          "add_state": "ADDRESS_STATE_1",
          "zip": "ADDRESS_ZIP_1",
          "state": "active",
          "address_name": "ADDRESS_NAME_1"
        }
      },
      {
        "id": 36002,
        "address_id": "ADDRESS_ID_1",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Paper Towels",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1500,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7011,
          "name": "Paper Towels",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 502,
            "name": "Paper Towels",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/paper-towel.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1",
          "add_state": "ADDRESS_STATE_1",
          "zip": "ADDRESS_ZIP_1",
          "state": "active",
          "address_name": "ADDRESS_NAME_1"
        }
      },
      {
        "id": 36003,
        "address_id": "ADDRESS_ID_1",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Hand Soap",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 700,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7012,
          "name": "Hand Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 503,
            "name": "Hand Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1",
          "add_state": "ADDRESS_STATE_1",
          "zip": "ADDRESS_ZIP_1",
          "state": "active",
          "address_name": "ADDRESS_NAME_1"
        }
      },
      {
        "id": 36004,
        "address_id": "ADDRESS_ID_1",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Dish Soap",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 600,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7013,
          "name": "Dish Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 506,
            "name": "Dish Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1",
          "add_state": "ADDRESS_STATE_1",
          "zip": "ADDRESS_ZIP_1",
          "state": "active",
          "address_name": "ADDRESS_NAME_1"
        }
      },
      {
        "id": 36005,
        "address_id": "ADDRESS_ID_1",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Trash Bags",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1100,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7014,
          "name": "Trash Bags",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 511,
            "name": "Trash Bags",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/trash_service.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1",
          "add_state": "ADDRESS_STATE_1",
          "zip": "ADDRESS_ZIP_1",
          "state": "active",
          "address_name": "ADDRESS_NAME_1"
        }
      },
      {
        "id": 36006,
        "address_id": "ADDRESS_ID_1",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Coffee",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 2400,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7015,
          "name": "Coffee",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 504,
            "name": "Coffee",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hot-drink.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1",
          "add_state": "ADDRESS_STATE_1",
          "zip": "ADDRESS_ZIP_1",
          "state": "active",
          "address_name": "ADDRESS_NAME_1"
        }
      },
      {
        "id": 36007,
        "address_id": "ADDRESS_ID_1",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Shampoo",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 900,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7016,
          "name": "Shampoo",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 508,
            "name": "Shampoo",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1",
          "add_state": "ADDRESS_STATE_1",
          "zip": "ADDRESS_ZIP_1",
          "state": "active",
          "address_name": "ADDRESS_NAME_1"
        }
      },
      {
        "id": 36008,
        "address_id": "ADDRESS_ID_1",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Conditioner",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 900,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7017,
          "name": "Conditioner",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 515,
            "name": "Conditioner",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_1",
          "address1": "ADDRESS_LINE1_1",
          "address2": null,
          "city": "ADDRESS_CITY_1",
          "add_state": "ADDRESS_STATE_1",
          "zip": "ADDRESS_ZIP_1",
          "state": "active",
          "address_name": "ADDRESS_NAME_1"
        }
      },
      {
        "id": 35010,
        "address_id": "ADDRESS_ID_2",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-11-03",
        "description": null,
        "name": "Smart TV",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7018,
          "name": "Smart TV",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 248,
            "name": "Smart TV",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2",
          "add_state": "ADDRESS_STATE_2",
          "zip": "ADDRESS_ZIP_2",
          "state": "active",
          "address_name": "ADDRESS_NAME_2"
        }
      },
      {
        "id": 35011,
        "address_id": "ADDRESS_ID_2",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-11-03",
        "description": null,
        "name": "Refrigerator",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7019,
          "name": "Refrigerator",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 413,
            "name": "Refrigerator",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/refrigerator (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2",
          "add_state": "ADDRESS_STATE_2",
          "zip": "ADDRESS_ZIP_2",
          "state": "active",
          "address_name": "ADDRESS_NAME_2"
        }
      },
      {
        "id": 35012,
        "address_id": "ADDRESS_ID_2",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-11-03",
        "description": null,
        "name": "Microwave",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7020,
          "name": "Microwave",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 428,
            "name": "Microwave",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/microwave.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2",
          "add_state": "ADDRESS_STATE_2",
          "zip": "ADDRESS_ZIP_2",
          "state": "active",
          "address_name": "ADDRESS_NAME_2"
        }
      },
      {
        "id": 35013,
        "address_id": "ADDRESS_ID_2",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-11-03",
        "description": null,
        "name": "Coffee Maker",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7021,
          "name": "Coffee Maker",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 516,
            "name": "Coffee Maker",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/coffee-pot (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2",
          "add_state": "ADDRESS_STATE_2",
          "zip": "ADDRESS_ZIP_2",
          "state": "active",
          "address_name": "ADDRESS_NAME_2"
        }
      },
      {
        "id": 35014,
        "address_id": "ADDRESS_ID_2",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-11-03",
        "description": null,
        "name": "Air Conditioner",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7022,
          "name": "Air Conditioner",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 414,
            "name": "Air Conditioner",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/air-conditioner.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2",
          "add_state": "ADDRESS_STATE_2",
          "zip": "ADDRESS_ZIP_2",
          "state": "active",
          "address_name": "ADDRESS_NAME_2"
        }
      },
      {
        "id": 35015,
        "address_id": "ADDRESS_ID_2",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-11-03",
        "description": null,
        "name": "Washer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7023,
          "name": "Washer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 432,
            "name": "Washer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/washing-machine.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2",
          "add_state": "ADDRESS_STATE_2",
          "zip": "ADDRESS_ZIP_2",
          "state": "active",
          "address_name": "ADDRESS_NAME_2"
        }
      },
      {
        "id": 35016,
        "address_id": "ADDRESS_ID_2",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-11-03",
        "description": null,
        "name": "Dryer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7024,
          "name": "Dryer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 433,
            "name": "Dryer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/dryer.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2",
          "add_state": "ADDRESS_STATE_2",
          "zip": "ADDRESS_ZIP_2",
          "state": "active",
          "address_name": "ADDRESS_NAME_2"
        }
      },
      {
        "id": 35017,
        "address_id": "ADDRESS_ID_2",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-11-03",
        "description": null,
        "name": "Toaster",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7025,
          "name": "Toaster",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 517,
            "name": "Toaster",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/toaster (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2",
          "add_state": "ADDRESS_STATE_2",
          "zip": "ADDRESS_ZIP_2",
          "state": "active",
          "address_name": "ADDRESS_NAME_2"
        }
      },
      {
        "id": 35018,
        "address_id": "ADDRESS_ID_2",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-11-03",
        "description": null,
        "name": "Blender",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7026,
          "name": "Blender",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 434,
            "name": "Blender",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/blender.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2",
          "add_state": "ADDRESS_STATE_2",
          "zip": "ADDRESS_ZIP_2",
          "state": "active",
          "address_name": "ADDRESS_NAME_2"
        }
      },
      {
        "id": 36009,
        "address_id": "ADDRESS_ID_2",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Toilet Paper",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1800,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7027,
          "name": "Toilet Paper",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 501,
            "name": "Toilet Paper",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/toilet-paper.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2",
          "add_state": "ADDRESS_STATE_2",
          "zip": "ADDRESS_ZIP_2",
          "state": "active",
          "address_name": "ADDRESS_NAME_2"
        }
      },
      {
        "id": 36010,
        "address_id": "ADDRESS_ID_2",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Paper Towels",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 1500,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7028,
          "name": "Paper Towels",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 502,
            "name": "Paper Towels",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/paper-towel.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2",
          "add_state": "ADDRESS_STATE_2",
          "zip": "ADDRESS_ZIP_2",
          "state": "active",
          "address_name": "ADDRESS_NAME_2"
        }
      },
      {
        "id": 36011,
        "address_id": "ADDRESS_ID_2",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Hand Soap",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 700,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7029,
          "name": "Hand Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 503,
            "name": "Hand Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2",
          "add_state": "ADDRESS_STATE_2",
          "zip": "ADDRESS_ZIP_2",
          "state": "active",
          "address_name": "ADDRESS_NAME_2"
        }
      },
      {
        "id": 36012,
        "address_id": "ADDRESS_ID_2",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Dish Soap",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 600,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7030,
          "name": "Dish Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 506,
            "name": "Dish Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2",
          "add_state": "ADDRESS_STATE_2",
          "zip": "ADDRESS_ZIP_2",
          "state": "active",
          "address_name": "ADDRESS_NAME_2"
        }
      },
      {
        "id": 36013,
        "address_id": "ADDRESS_ID_2",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Trash Bags",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 1100,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7031,
          "name": "Trash Bags",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 511,
            "name": "Trash Bags",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/trash_service.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2",
          "add_state": "ADDRESS_STATE_2",
          "zip": "ADDRESS_ZIP_2",
          "state": "active",
          "address_name": "ADDRESS_NAME_2"
        }
      },
      {
        "id": 36014,
        "address_id": "ADDRESS_ID_2",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Coffee",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 2400,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7032,
          "name": "Coffee",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 504,
            "name": "Coffee",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hot-drink.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2",
          "add_state": "ADDRESS_STATE_2",
          "zip": "ADDRESS_ZIP_2",
          "state": "active",
          "address_name": "ADDRESS_NAME_2"
        }
      },
      {
        "id": 36015,
        "address_id": "ADDRESS_ID_2",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Body Wash",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 850,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7033,
          "name": "Body Wash",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 514,
            "name": "Body Wash",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2",
          "add_state": "ADDRESS_STATE_2",
          "zip": "ADDRESS_ZIP_2",
          "state": "active",
          "address_name": "ADDRESS_NAME_2"
        }
      },
      {
        "id": 36016,
        "address_id": "ADDRESS_ID_2",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Laundry Detergent",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 1600,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7034,
          "name": "Laundry Detergent",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 505,
            "name": "Laundry Detergent",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/laundry.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_2",
          "address1": "ADDRESS_LINE1_2",
          "address2": null,
          "city": "ADDRESS_CITY_2",
          "add_state": "ADDRESS_STATE_2",
          "zip": "ADDRESS_ZIP_2",
          "state": "active",
          "address_name": "ADDRESS_NAME_2"
        }
      },
      {
        "id": 35019,
        "address_id": "ADDRESS_ID_3",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-02-18",
        "description": null,
        "name": "Smart TV",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7035,
          "name": "Smart TV",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 248,
            "name": "Smart TV",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3",
          "add_state": "ADDRESS_STATE_3",
          "zip": "ADDRESS_ZIP_3",
          "state": "active",
          "address_name": "ADDRESS_NAME_3"
        }
      },
      {
        "id": 35020,
        "address_id": "ADDRESS_ID_3",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-02-18",
        "description": null,
        "name": "Refrigerator",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7036,
          "name": "Refrigerator",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 413,
            "name": "Refrigerator",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/refrigerator (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3",
          "add_state": "ADDRESS_STATE_3",
          "zip": "ADDRESS_ZIP_3",
          "state": "active",
          "address_name": "ADDRESS_NAME_3"
        }
      },
      {
        "id": 35021,
        "address_id": "ADDRESS_ID_3",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-02-18",
        "description": null,
        "name": "Microwave",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7037,
          "name": "Microwave",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 428,
            "name": "Microwave",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/microwave.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3",
          "add_state": "ADDRESS_STATE_3",
          "zip": "ADDRESS_ZIP_3",
          "state": "active",
          "address_name": "ADDRESS_NAME_3"
        }
      },
      {
        "id": 35022,
        "address_id": "ADDRESS_ID_3",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-02-18",
        "description": null,
        "name": "Coffee Maker",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7038,
          "name": "Coffee Maker",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 516,
            "name": "Coffee Maker",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/coffee-pot (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3",
          "add_state": "ADDRESS_STATE_3",
          "zip": "ADDRESS_ZIP_3",
          "state": "active",
          "address_name": "ADDRESS_NAME_3"
        }
      },
      {
        "id": 35023,
        "address_id": "ADDRESS_ID_3",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-02-18",
        "description": null,
        "name": "Air Conditioner",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7039,
          "name": "Air Conditioner",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 414,
            "name": "Air Conditioner",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/air-conditioner.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3",
          "add_state": "ADDRESS_STATE_3",
          "zip": "ADDRESS_ZIP_3",
          "state": "active",
          "address_name": "ADDRESS_NAME_3"
        }
      },
      {
        "id": 35024,
        "address_id": "ADDRESS_ID_3",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-02-18",
        "description": null,
        "name": "Washer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7040,
          "name": "Washer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 432,
            "name": "Washer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/washing-machine.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3",
          "add_state": "ADDRESS_STATE_3",
          "zip": "ADDRESS_ZIP_3",
          "state": "active",
          "address_name": "ADDRESS_NAME_3"
        }
      },
      {
        "id": 35025,
        "address_id": "ADDRESS_ID_3",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-02-18",
        "description": null,
        "name": "Dryer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7041,
          "name": "Dryer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 433,
            "name": "Dryer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/dryer.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3",
          "add_state": "ADDRESS_STATE_3",
          "zip": "ADDRESS_ZIP_3",
          "state": "active",
          "address_name": "ADDRESS_NAME_3"
        }
      },
      {
        "id": 35026,
        "address_id": "ADDRESS_ID_3",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-02-18",
        "description": null,
        "name": "Vacuum",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7042,
          "name": "Vacuum",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 412,
            "name": "Vacuum",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/vacuum.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3",
          "add_state": "ADDRESS_STATE_3",
          "zip": "ADDRESS_ZIP_3",
          "state": "active",
          "address_name": "ADDRESS_NAME_3"
        }
      },
      {
        "id": 35027,
        "address_id": "ADDRESS_ID_3",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-02-18",
        "description": null,
        "name": "Dining Table",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7043,
          "name": "Dining Table",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 249,
            "name": "Dining Table",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/table.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3",
          "add_state": "ADDRESS_STATE_3",
          "zip": "ADDRESS_ZIP_3",
          "state": "active",
          "address_name": "ADDRESS_NAME_3"
        }
      },
      {
        "id": 36017,
        "address_id": "ADDRESS_ID_3",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Toilet Paper",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 1800,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7044,
          "name": "Toilet Paper",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 501,
            "name": "Toilet Paper",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/toilet-paper.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3",
          "add_state": "ADDRESS_STATE_3",
          "zip": "ADDRESS_ZIP_3",
          "state": "active",
          "address_name": "ADDRESS_NAME_3"
        }
      },
      {
        "id": 36018,
        "address_id": "ADDRESS_ID_3",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Paper Towels",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1500,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7045,
          "name": "Paper Towels",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 502,
            "name": "Paper Towels",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/paper-towel.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3",
          "add_state": "ADDRESS_STATE_3",
          "zip": "ADDRESS_ZIP_3",
          "state": "active",
          "address_name": "ADDRESS_NAME_3"
        }
      },
      {
        "id": 36019,
        "address_id": "ADDRESS_ID_3",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Hand Soap",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 700,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7046,
          "name": "Hand Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 503,
            "name": "Hand Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3",
          "add_state": "ADDRESS_STATE_3",
          "zip": "ADDRESS_ZIP_3",
          "state": "active",
          "address_name": "ADDRESS_NAME_3"
        }
      },
      {
        "id": 36020,
        "address_id": "ADDRESS_ID_3",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Dish Soap",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 600,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7047,
          "name": "Dish Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 506,
            "name": "Dish Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3",
          "add_state": "ADDRESS_STATE_3",
          "zip": "ADDRESS_ZIP_3",
          "state": "active",
          "address_name": "ADDRESS_NAME_3"
        }
      },
      {
        "id": 36021,
        "address_id": "ADDRESS_ID_3",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Trash Bags",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1100,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7048,
          "name": "Trash Bags",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 511,
            "name": "Trash Bags",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/trash_service.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3",
          "add_state": "ADDRESS_STATE_3",
          "zip": "ADDRESS_ZIP_3",
          "state": "active",
          "address_name": "ADDRESS_NAME_3"
        }
      },
      {
        "id": 36022,
        "address_id": "ADDRESS_ID_3",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Coffee",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 2400,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7049,
          "name": "Coffee",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 504,
            "name": "Coffee",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hot-drink.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3",
          "add_state": "ADDRESS_STATE_3",
          "zip": "ADDRESS_ZIP_3",
          "state": "active",
          "address_name": "ADDRESS_NAME_3"
        }
      },
      {
        "id": 36023,
        "address_id": "ADDRESS_ID_3",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "All-Purpose Cleaner",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 800,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7050,
          "name": "All-Purpose Cleaner",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 507,
            "name": "All-Purpose Cleaner",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/cleaner.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3",
          "add_state": "ADDRESS_STATE_3",
          "zip": "ADDRESS_ZIP_3",
          "state": "active",
          "address_name": "ADDRESS_NAME_3"
        }
      },
      {
        "id": 36024,
        "address_id": "ADDRESS_ID_3",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Glass Cleaner",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 650,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7051,
          "name": "Glass Cleaner",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 512,
            "name": "Glass Cleaner",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/cleaner.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_3",
          "address1": "ADDRESS_LINE1_3",
          "address2": null,
          "city": "ADDRESS_CITY_3",
          "add_state": "ADDRESS_STATE_3",
          "zip": "ADDRESS_ZIP_3",
          "state": "active",
          "address_name": "ADDRESS_NAME_3"
        }
      },
      {
        "id": 35028,
        "address_id": "ADDRESS_ID_4",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-09-09",
        "description": null,
        "name": "Smart TV",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7052,
          "name": "Smart TV",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 248,
            "name": "Smart TV",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_4",
          "address1": "ADDRESS_LINE1_4",
          "address2": null,
          "city": "ADDRESS_CITY_4",
          "add_state": "ADDRESS_STATE_4",
          "zip": "ADDRESS_ZIP_4",
          "state": "active",
          "address_name": "ADDRESS_NAME_4"
        }
      },
      {
        "id": 35029,
        "address_id": "ADDRESS_ID_4",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-09-09",
        "description": null,
        "name": "Refrigerator",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7053,
          "name": "Refrigerator",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 413,
            "name": "Refrigerator",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/refrigerator (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_4",
          "address1": "ADDRESS_LINE1_4",
          "address2": null,
          "city": "ADDRESS_CITY_4",
          "add_state": "ADDRESS_STATE_4",
          "zip": "ADDRESS_ZIP_4",
          "state": "active",
          "address_name": "ADDRESS_NAME_4"
        }
      },
      {
        "id": 35030,
        "address_id": "ADDRESS_ID_4",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-09-09",
        "description": null,
        "name": "Microwave",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7054,
          "name": "Microwave",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 428,
            "name": "Microwave",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/microwave.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_4",
          "address1": "ADDRESS_LINE1_4",
          "address2": null,
          "city": "ADDRESS_CITY_4",
          "add_state": "ADDRESS_STATE_4",
          "zip": "ADDRESS_ZIP_4",
          "state": "active",
          "address_name": "ADDRESS_NAME_4"
        }
      },
      {
        "id": 35031,
        "address_id": "ADDRESS_ID_4",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-09-09",
        "description": null,
        "name": "Coffee Maker",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7055,
          "name": "Coffee Maker",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 516,
            "name": "Coffee Maker",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/coffee-pot (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_4",
          "address1": "ADDRESS_LINE1_4",
          "address2": null,
          "city": "ADDRESS_CITY_4",
          "add_state": "ADDRESS_STATE_4",
          "zip": "ADDRESS_ZIP_4",
          "state": "active",
          "address_name": "ADDRESS_NAME_4"
        }
      },
      {
        "id": 35032,
        "address_id": "ADDRESS_ID_4",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-09-09",
        "description": null,
        "name": "Air Conditioner",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7056,
          "name": "Air Conditioner",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 414,
            "name": "Air Conditioner",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/air-conditioner.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_4",
          "address1": "ADDRESS_LINE1_4",
          "address2": null,
          "city": "ADDRESS_CITY_4",
          "add_state": "ADDRESS_STATE_4",
          "zip": "ADDRESS_ZIP_4",
          "state": "active",
          "address_name": "ADDRESS_NAME_4"
        }
      },
      {
        "id": 35033,
        "address_id": "ADDRESS_ID_4",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-09-09",
        "description": null,
        "name": "Washer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7057,
          "name": "Washer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 432,
            "name": "Washer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/washing-machine.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_4",
          "address1": "ADDRESS_LINE1_4",
          "address2": null,
          "city": "ADDRESS_CITY_4",
          "add_state": "ADDRESS_STATE_4",
          "zip": "ADDRESS_ZIP_4",
          "state": "active",
          "address_name": "ADDRESS_NAME_4"
        }
      },
      {
        "id": 35034,
        "address_id": "ADDRESS_ID_4",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-09-09",
        "description": null,
        "name": "Dryer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7058,
          "name": "Dryer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 433,
            "name": "Dryer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/dryer.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_4",
          "address1": "ADDRESS_LINE1_4",
          "address2": null,
          "city": "ADDRESS_CITY_4",
          "add_state": "ADDRESS_STATE_4",
          "zip": "ADDRESS_ZIP_4",
          "state": "active",
          "address_name": "ADDRESS_NAME_4"
        }
      },
      {
        "id": 35035,
        "address_id": "ADDRESS_ID_4",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-09-09",
        "description": null,
        "name": "Wine Glasses",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7059,
          "name": "Wine Glasses",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 440,
            "name": "Wine Glasses",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/wineglass.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_4",
          "address1": "ADDRESS_LINE1_4",
          "address2": null,
          "city": "ADDRESS_CITY_4",
          "add_state": "ADDRESS_STATE_4",
          "zip": "ADDRESS_ZIP_4",
          "state": "active",
          "address_name": "ADDRESS_NAME_4"
        }
      },
      {
        "id": 35036,
        "address_id": "ADDRESS_ID_4",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-09-09",
        "description": null,
        "name": "Iron",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7060,
          "name": "Iron",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 435,
            "name": "Iron",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/electrical.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_4",
          "address1": "ADDRESS_LINE1_4",
          "address2": null,
          "city": "ADDRESS_CITY_4",
          "add_state": "ADDRESS_STATE_4",
          "zip": "ADDRESS_ZIP_4",
          "state": "active",
          "address_name": "ADDRESS_NAME_4"
        }
      },
      {
        "id": 36025,
        "address_id": "ADDRESS_ID_4",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Toilet Paper",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1800,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7061,
          "name": "Toilet Paper",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 501,
            "name": "Toilet Paper",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/toilet-paper.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_4",
          "address1": "ADDRESS_LINE1_4",
          "address2": null,
          "city": "ADDRESS_CITY_4",
          "add_state": "ADDRESS_STATE_4",
          "zip": "ADDRESS_ZIP_4",
          "state": "active",
          "address_name": "ADDRESS_NAME_4"
        }
      },
      {
        "id": 36026,
        "address_id": "ADDRESS_ID_4",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Paper Towels",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1500,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7062,
          "name": "Paper Towels",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 502,
            "name": "Paper Towels",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/paper-towel.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_4",
          "address1": "ADDRESS_LINE1_4",
          "address2": null,
          "city": "ADDRESS_CITY_4",
          "add_state": "ADDRESS_STATE_4",
          "zip": "ADDRESS_ZIP_4",
          "state": "active",
          "address_name": "ADDRESS_NAME_4"
        }
      },
      {
        "id": 36027,
        "address_id": "ADDRESS_ID_4",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Hand Soap",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 700,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7063,
          "name": "Hand Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 503,
            "name": "Hand Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_4",
          "address1": "ADDRESS_LINE1_4",
          "address2": null,
          "city": "ADDRESS_CITY_4",
          "add_state": "ADDRESS_STATE_4",
          "zip": "ADDRESS_ZIP_4",
          "state": "active",
          "address_name": "ADDRESS_NAME_4"
        }
      },
      {
        "id": 36028,
        "address_id": "ADDRESS_ID_4",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Dish Soap",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 600,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7064,
          "name": "Dish Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 506,
            "name": "Dish Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_4",
          "address1": "ADDRESS_LINE1_4",
          "address2": null,
          "city": "ADDRESS_CITY_4",
          "add_state": "ADDRESS_STATE_4",
          "zip": "ADDRESS_ZIP_4",
          "state": "active",
          "address_name": "ADDRESS_NAME_4"
        }
      },
      {
        "id": 36029,
        "address_id": "ADDRESS_ID_4",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Trash Bags",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1100,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7065,
          "name": "Trash Bags",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 511,
            "name": "Trash Bags",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/trash_service.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_4",
          "address1": "ADDRESS_LINE1_4",
          "address2": null,
          "city": "ADDRESS_CITY_4",
          "add_state": "ADDRESS_STATE_4",
          "zip": "ADDRESS_ZIP_4",
          "state": "active",
          "address_name": "ADDRESS_NAME_4"
        }
      },
      {
        "id": 36030,
        "address_id": "ADDRESS_ID_4",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Coffee",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 2400,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7066,
          "name": "Coffee",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 504,
            "name": "Coffee",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hot-drink.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_4",
          "address1": "ADDRESS_LINE1_4",
          "address2": null,
          "city": "ADDRESS_CITY_4",
          "add_state": "ADDRESS_STATE_4",
          "zip": "ADDRESS_ZIP_4",
          "state": "active",
          "address_name": "ADDRESS_NAME_4"
        }
      },
      {
        "id": 36031,
        "address_id": "ADDRESS_ID_4",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Disinfecting Wipes",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 750,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7067,
          "name": "Disinfecting Wipes",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 509,
            "name": "Disinfecting Wipes",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/wipes.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_4",
          "address1": "ADDRESS_LINE1_4",
          "address2": null,
          "city": "ADDRESS_CITY_4",
          "add_state": "ADDRESS_STATE_4",
          "zip": "ADDRESS_ZIP_4",
          "state": "active",
          "address_name": "ADDRESS_NAME_4"
        }
      },
      {
        "id": 36032,
        "address_id": "ADDRESS_ID_4",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Light Bulbs",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1400,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7068,
          "name": "Light Bulbs",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 744,
            "name": "Light Bulbs",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/light-bulb (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_4",
          "address1": "ADDRESS_LINE1_4",
          "address2": null,
          "city": "ADDRESS_CITY_4",
          "add_state": "ADDRESS_STATE_4",
          "zip": "ADDRESS_ZIP_4",
          "state": "active",
          "address_name": "ADDRESS_NAME_4"
        }
      },
      {
        "id": 35037,
        "address_id": "ADDRESS_ID_5",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-01-20",
        "description": null,
        "name": "Smart TV",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7069,
          "name": "Smart TV",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 248,
            "name": "Smart TV",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_5",
          "address1": "ADDRESS_LINE1_5",
          "address2": null,
          "city": "ADDRESS_CITY_5",
          "add_state": "ADDRESS_STATE_5",
          "zip": "ADDRESS_ZIP_5",
          "state": "active",
          "address_name": "ADDRESS_NAME_5"
        }
      },
      {
        "id": 35038,
        "address_id": "ADDRESS_ID_5",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-01-20",
        "description": null,
        "name": "Refrigerator",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7070,
          "name": "Refrigerator",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 413,
            "name": "Refrigerator",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/refrigerator (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_5",
          "address1": "ADDRESS_LINE1_5",
          "address2": null,
          "city": "ADDRESS_CITY_5",
          "add_state": "ADDRESS_STATE_5",
          "zip": "ADDRESS_ZIP_5",
          "state": "active",
          "address_name": "ADDRESS_NAME_5"
        }
      },
      {
        "id": 35039,
        "address_id": "ADDRESS_ID_5",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-01-20",
        "description": null,
        "name": "Microwave",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7071,
          "name": "Microwave",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 428,
            "name": "Microwave",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/microwave.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_5",
          "address1": "ADDRESS_LINE1_5",
          "address2": null,
          "city": "ADDRESS_CITY_5",
          "add_state": "ADDRESS_STATE_5",
          "zip": "ADDRESS_ZIP_5",
          "state": "active",
          "address_name": "ADDRESS_NAME_5"
        }
      },
      {
        "id": 35040,
        "address_id": "ADDRESS_ID_5",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-01-20",
        "description": null,
        "name": "Coffee Maker",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7072,
          "name": "Coffee Maker",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 516,
            "name": "Coffee Maker",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/coffee-pot (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_5",
          "address1": "ADDRESS_LINE1_5",
          "address2": null,
          "city": "ADDRESS_CITY_5",
          "add_state": "ADDRESS_STATE_5",
          "zip": "ADDRESS_ZIP_5",
          "state": "active",
          "address_name": "ADDRESS_NAME_5"
        }
      },
      {
        "id": 35041,
        "address_id": "ADDRESS_ID_5",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-01-20",
        "description": null,
        "name": "Air Conditioner",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7073,
          "name": "Air Conditioner",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 414,
            "name": "Air Conditioner",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/air-conditioner.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_5",
          "address1": "ADDRESS_LINE1_5",
          "address2": null,
          "city": "ADDRESS_CITY_5",
          "add_state": "ADDRESS_STATE_5",
          "zip": "ADDRESS_ZIP_5",
          "state": "active",
          "address_name": "ADDRESS_NAME_5"
        }
      },
      {
        "id": 35042,
        "address_id": "ADDRESS_ID_5",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-01-20",
        "description": null,
        "name": "Washer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7074,
          "name": "Washer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 432,
            "name": "Washer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/washing-machine.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_5",
          "address1": "ADDRESS_LINE1_5",
          "address2": null,
          "city": "ADDRESS_CITY_5",
          "add_state": "ADDRESS_STATE_5",
          "zip": "ADDRESS_ZIP_5",
          "state": "active",
          "address_name": "ADDRESS_NAME_5"
        }
      },
      {
        "id": 35043,
        "address_id": "ADDRESS_ID_5",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-01-20",
        "description": null,
        "name": "Dryer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7075,
          "name": "Dryer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 433,
            "name": "Dryer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/dryer.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_5",
          "address1": "ADDRESS_LINE1_5",
          "address2": null,
          "city": "ADDRESS_CITY_5",
          "add_state": "ADDRESS_STATE_5",
          "zip": "ADDRESS_ZIP_5",
          "state": "active",
          "address_name": "ADDRESS_NAME_5"
        }
      },
      {
        "id": 35044,
        "address_id": "ADDRESS_ID_5",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-01-20",
        "description": null,
        "name": "Ironing Board",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7076,
          "name": "Ironing Board",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 436,
            "name": "Ironing Board",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/ironing.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_5",
          "address1": "ADDRESS_LINE1_5",
          "address2": null,
          "city": "ADDRESS_CITY_5",
          "add_state": "ADDRESS_STATE_5",
          "zip": "ADDRESS_ZIP_5",
          "state": "active",
          "address_name": "ADDRESS_NAME_5"
        }
      },
      {
        "id": 35045,
        "address_id": "ADDRESS_ID_5",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-01-20",
        "description": null,
        "name": "Hair Dryer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7077,
          "name": "Hair Dryer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 439,
            "name": "Hair Dryer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hair-dryer.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_5",
          "address1": "ADDRESS_LINE1_5",
          "address2": null,
          "city": "ADDRESS_CITY_5",
          "add_state": "ADDRESS_STATE_5",
          "zip": "ADDRESS_ZIP_5",
          "state": "active",
          "address_name": "ADDRESS_NAME_5"
        }
      },
      {
        "id": 36033,
        "address_id": "ADDRESS_ID_5",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Toilet Paper",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1800,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7078,
          "name": "Toilet Paper",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 501,
            "name": "Toilet Paper",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/toilet-paper.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_5",
          "address1": "ADDRESS_LINE1_5",
          "address2": null,
          "city": "ADDRESS_CITY_5",
          "add_state": "ADDRESS_STATE_5",
          "zip": "ADDRESS_ZIP_5",
          "state": "active",
          "address_name": "ADDRESS_NAME_5"
        }
      },
      {
        "id": 36034,
        "address_id": "ADDRESS_ID_5",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Paper Towels",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 1500,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7079,
          "name": "Paper Towels",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 502,
            "name": "Paper Towels",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/paper-towel.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_5",
          "address1": "ADDRESS_LINE1_5",
          "address2": null,
          "city": "ADDRESS_CITY_5",
          "add_state": "ADDRESS_STATE_5",
          "zip": "ADDRESS_ZIP_5",
          "state": "active",
          "address_name": "ADDRESS_NAME_5"
        }
      },
      {
        "id": 36035,
        "address_id": "ADDRESS_ID_5",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Hand Soap",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 700,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7080,
          "name": "Hand Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 503,
            "name": "Hand Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_5",
          "address1": "ADDRESS_LINE1_5",
          "address2": null,
          "city": "ADDRESS_CITY_5",
          "add_state": "ADDRESS_STATE_5",
          "zip": "ADDRESS_ZIP_5",
          "state": "active",
          "address_name": "ADDRESS_NAME_5"
        }
      },
      {
        "id": 36036,
        "address_id": "ADDRESS_ID_5",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Dish Soap",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 600,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7081,
          "name": "Dish Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 506,
            "name": "Dish Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_5",
          "address1": "ADDRESS_LINE1_5",
          "address2": null,
          "city": "ADDRESS_CITY_5",
          "add_state": "ADDRESS_STATE_5",
          "zip": "ADDRESS_ZIP_5",
          "state": "active",
          "address_name": "ADDRESS_NAME_5"
        }
      },
      {
        "id": 36037,
        "address_id": "ADDRESS_ID_5",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Trash Bags",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 1100,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7082,
          "name": "Trash Bags",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 511,
            "name": "Trash Bags",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/trash_service.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_5",
          "address1": "ADDRESS_LINE1_5",
          "address2": null,
          "city": "ADDRESS_CITY_5",
          "add_state": "ADDRESS_STATE_5",
          "zip": "ADDRESS_ZIP_5",
          "state": "active",
          "address_name": "ADDRESS_NAME_5"
        }
      },
      {
        "id": 36038,
        "address_id": "ADDRESS_ID_5",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Coffee",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 2400,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7083,
          "name": "Coffee",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 504,
            "name": "Coffee",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hot-drink.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_5",
          "address1": "ADDRESS_LINE1_5",
          "address2": null,
          "city": "ADDRESS_CITY_5",
          "add_state": "ADDRESS_STATE_5",
          "zip": "ADDRESS_ZIP_5",
          "state": "active",
          "address_name": "ADDRESS_NAME_5"
        }
      },
      {
        "id": 36039,
        "address_id": "ADDRESS_ID_5",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Tea",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 900,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7084,
          "name": "Tea",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 510,
            "name": "Tea",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tea.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_5",
          "address1": "ADDRESS_LINE1_5",
          "address2": null,
          "city": "ADDRESS_CITY_5",
          "add_state": "ADDRESS_STATE_5",
          "zip": "ADDRESS_ZIP_5",
          "state": "active",
          "address_name": "ADDRESS_NAME_5"
        }
      },
      {
        "id": 36040,
        "address_id": "ADDRESS_ID_5",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Bottled Water",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 1000,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7085,
          "name": "Bottled Water",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 513,
            "name": "Bottled Water",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/glass-of-water.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_5",
          "address1": "ADDRESS_LINE1_5",
          "address2": null,
          "city": "ADDRESS_CITY_5",
          "add_state": "ADDRESS_STATE_5",
          "zip": "ADDRESS_ZIP_5",
          "state": "active",
          "address_name": "ADDRESS_NAME_5"
        }
      },
      {
        "id": 35046,
        "address_id": "ADDRESS_ID_6",
        "consumable": false,
        "state": "active",
        "installation_date": "2021-08-14",
        "description": null,
        "name": "Smart TV",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7086,
          "name": "Smart TV",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 248,
            "name": "Smart TV",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_6",
          "address1": "ADDRESS_LINE1_6",
          "address2": null,
          "city": "ADDRESS_CITY_6",
          "add_state": "ADDRESS_STATE_6",
          "zip": "ADDRESS_ZIP_6",
          "state": "active",
          "address_name": "ADDRESS_NAME_6"
        }
      },
      {
        "id": 35047,
        "address_id": "ADDRESS_ID_6",
        "consumable": false,
        "state": "active",
        "installation_date": "2021-08-14",
        "description": null,
        "name": "Refrigerator",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7087,
          "name": "Refrigerator",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 413,
            "name": "Refrigerator",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/refrigerator (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_6",
          "address1": "ADDRESS_LINE1_6",
          "address2": null,
          "city": "ADDRESS_CITY_6",
          "add_state": "ADDRESS_STATE_6",
          "zip": "ADDRESS_ZIP_6",
          "state": "active",
          "address_name": "ADDRESS_NAME_6"
        }
      },
      {
        "id": 35048,
        "address_id": "ADDRESS_ID_6",
        "consumable": false,
        "state": "active",
        "installation_date": "2021-08-14",
        "description": null,
        "name": "Microwave",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7088,
          "name": "Microwave",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 428,
            "name": "Microwave",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/microwave.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_6",
          "address1": "ADDRESS_LINE1_6",
          "address2": null,
          "city": "ADDRESS_CITY_6",
          "add_state": "ADDRESS_STATE_6",
          "zip": "ADDRESS_ZIP_6",
          "state": "active",
          "address_name": "ADDRESS_NAME_6"
        }
      },
      {
        "id": 35049,
        "address_id": "ADDRESS_ID_6",
        "consumable": false,
        "state": "active",
        "installation_date": "2021-08-14",
        "description": null,
        "name": "Coffee Maker",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7089,
          "name": "Coffee Maker",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 516,
            "name": "Coffee Maker",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/coffee-pot (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_6",
          "address1": "ADDRESS_LINE1_6",
          "address2": null,
          "city": "ADDRESS_CITY_6",
          "add_state": "ADDRESS_STATE_6",
          "zip": "ADDRESS_ZIP_6",
          "state": "active",
          "address_name": "ADDRESS_NAME_6"
        }
      },
      {
        "id": 35050,
        "address_id": "ADDRESS_ID_6",
        "consumable": false,
        "state": "active",
        "installation_date": "2021-08-14",
        "description": null,
        "name": "Air Conditioner",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7090,
          "name": "Air Conditioner",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 414,
            "name": "Air Conditioner",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/air-conditioner.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_6",
          "address1": "ADDRESS_LINE1_6",
          "address2": null,
          "city": "ADDRESS_CITY_6",
          "add_state": "ADDRESS_STATE_6",
          "zip": "ADDRESS_ZIP_6",
          "state": "active",
          "address_name": "ADDRESS_NAME_6"
        }
      },
      {
        "id": 35051,
        "address_id": "ADDRESS_ID_6",
        "consumable": false,
        "state": "active",
        "installation_date": "2021-08-14",
        "description": null,
        "name": "Washer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7091,
          "name": "Washer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 432,
            "name": "Washer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/washing-machine.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_6",
          "address1": "ADDRESS_LINE1_6",
          "address2": null,
          "city": "ADDRESS_CITY_6",
          "add_state": "ADDRESS_STATE_6",
          "zip": "ADDRESS_ZIP_6",
          "state": "active",
          "address_name": "ADDRESS_NAME_6"
        }
      },
      {
        "id": 35052,
        "address_id": "ADDRESS_ID_6",
        "consumable": false,
        "state": "active",
        "installation_date": "2021-08-14",
        "description": null,
        "name": "Dryer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7092,
          "name": "Dryer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 433,
            "name": "Dryer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/dryer.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_6",
          "address1": "ADDRESS_LINE1_6",
          "address2": null,
          "city": "ADDRESS_CITY_6",
          "add_state": "ADDRESS_STATE_6",
          "zip": "ADDRESS_ZIP_6",
          "state": "active",
          "address_name": "ADDRESS_NAME_6"
        }
      },
      {
        "id": 35053,
        "address_id": "ADDRESS_ID_6",
        "consumable": false,
        "state": "active",
        "installation_date": "2021-08-14",
        "description": null,
        "name": "Cookware Set",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7093,
          "name": "Cookware Set",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 442,
            "name": "Cookware Set",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/pot.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_6",
          "address1": "ADDRESS_LINE1_6",
          "address2": null,
          "city": "ADDRESS_CITY_6",
          "add_state": "ADDRESS_STATE_6",
          "zip": "ADDRESS_ZIP_6",
          "state": "active",
          "address_name": "ADDRESS_NAME_6"
        }
      },
      {
        "id": 35054,
        "address_id": "ADDRESS_ID_6",
        "consumable": false,
        "state": "active",
        "installation_date": "2021-08-14",
        "description": null,
        "name": "Frying Pan",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7094,
          "name": "Frying Pan",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 441,
            "name": "Frying Pan",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/frying-pan.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_6",
          "address1": "ADDRESS_LINE1_6",
          "address2": null,
          "city": "ADDRESS_CITY_6",
          "add_state": "ADDRESS_STATE_6",
          "zip": "ADDRESS_ZIP_6",
          "state": "active",
          "address_name": "ADDRESS_NAME_6"
        }
      },
      {
        "id": 36041,
        "address_id": "ADDRESS_ID_6",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Toilet Paper",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 1800,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7095,
          "name": "Toilet Paper",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 501,
            "name": "Toilet Paper",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/toilet-paper.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_6",
          "address1": "ADDRESS_LINE1_6",
          "address2": null,
          "city": "ADDRESS_CITY_6",
          "add_state": "ADDRESS_STATE_6",
          "zip": "ADDRESS_ZIP_6",
          "state": "active",
          "address_name": "ADDRESS_NAME_6"
        }
      },
      {
        "id": 36042,
        "address_id": "ADDRESS_ID_6",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Paper Towels",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1500,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7096,
          "name": "Paper Towels",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 502,
            "name": "Paper Towels",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/paper-towel.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_6",
          "address1": "ADDRESS_LINE1_6",
          "address2": null,
          "city": "ADDRESS_CITY_6",
          "add_state": "ADDRESS_STATE_6",
          "zip": "ADDRESS_ZIP_6",
          "state": "active",
          "address_name": "ADDRESS_NAME_6"
        }
      },
      {
        "id": 36043,
        "address_id": "ADDRESS_ID_6",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Hand Soap",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 700,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7097,
          "name": "Hand Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 503,
            "name": "Hand Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_6",
          "address1": "ADDRESS_LINE1_6",
          "address2": null,
          "city": "ADDRESS_CITY_6",
          "add_state": "ADDRESS_STATE_6",
          "zip": "ADDRESS_ZIP_6",
          "state": "active",
          "address_name": "ADDRESS_NAME_6"
        }
      },
      {
        "id": 36044,
        "address_id": "ADDRESS_ID_6",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Dish Soap",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 600,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7098,
          "name": "Dish Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 506,
            "name": "Dish Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_6",
          "address1": "ADDRESS_LINE1_6",
          "address2": null,
          "city": "ADDRESS_CITY_6",
          "add_state": "ADDRESS_STATE_6",
          "zip": "ADDRESS_ZIP_6",
          "state": "active",
          "address_name": "ADDRESS_NAME_6"
        }
      },
      {
        "id": 36045,
        "address_id": "ADDRESS_ID_6",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Trash Bags",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1100,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7099,
          "name": "Trash Bags",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 511,
            "name": "Trash Bags",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/trash_service.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_6",
          "address1": "ADDRESS_LINE1_6",
          "address2": null,
          "city": "ADDRESS_CITY_6",
          "add_state": "ADDRESS_STATE_6",
          "zip": "ADDRESS_ZIP_6",
          "state": "active",
          "address_name": "ADDRESS_NAME_6"
        }
      },
      {
        "id": 36046,
        "address_id": "ADDRESS_ID_6",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Coffee",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 2400,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7100,
          "name": "Coffee",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 504,
            "name": "Coffee",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hot-drink.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_6",
          "address1": "ADDRESS_LINE1_6",
          "address2": null,
          "city": "ADDRESS_CITY_6",
          "add_state": "ADDRESS_STATE_6",
          "zip": "ADDRESS_ZIP_6",
          "state": "active",
          "address_name": "ADDRESS_NAME_6"
        }
      },
      {
        "id": 36047,
        "address_id": "ADDRESS_ID_6",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Bath Towels",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 2200,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7101,
          "name": "Bath Towels",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 518,
            "name": "Bath Towels",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/towels.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_6",
          "address1": "ADDRESS_LINE1_6",
          "address2": null,
          "city": "ADDRESS_CITY_6",
          "add_state": "ADDRESS_STATE_6",
          "zip": "ADDRESS_ZIP_6",
          "state": "active",
          "address_name": "ADDRESS_NAME_6"
        }
      },
      {
        "id": 36048,
        "address_id": "ADDRESS_ID_6",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Pillows",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1800,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7102,
          "name": "Pillows",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 520,
            "name": "Pillows",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/pillow.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_6",
          "address1": "ADDRESS_LINE1_6",
          "address2": null,
          "city": "ADDRESS_CITY_6",
          "add_state": "ADDRESS_STATE_6",
          "zip": "ADDRESS_ZIP_6",
          "state": "active",
          "address_name": "ADDRESS_NAME_6"
        }
      },
      {
        "id": 35055,
        "address_id": "ADDRESS_ID_7",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-12-01",
        "description": null,
        "name": "Smart TV",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7103,
          "name": "Smart TV",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 248,
            "name": "Smart TV",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_7",
          "address1": "ADDRESS_LINE1_7",
          "address2": null,
          "city": "ADDRESS_CITY_7",
          "add_state": "ADDRESS_STATE_7",
          "zip": "ADDRESS_ZIP_7",
          "state": "active",
          "address_name": "ADDRESS_NAME_7"
        }
      },
      {
        "id": 35056,
        "address_id": "ADDRESS_ID_7",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-12-01",
        "description": null,
        "name": "Refrigerator",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7104,
          "name": "Refrigerator",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 413,
            "name": "Refrigerator",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/refrigerator (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_7",
          "address1": "ADDRESS_LINE1_7",
          "address2": null,
          "city": "ADDRESS_CITY_7",
          "add_state": "ADDRESS_STATE_7",
          "zip": "ADDRESS_ZIP_7",
          "state": "active",
          "address_name": "ADDRESS_NAME_7"
        }
      },
      {
        "id": 35057,
        "address_id": "ADDRESS_ID_7",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-12-01",
        "description": null,
        "name": "Microwave",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7105,
          "name": "Microwave",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 428,
            "name": "Microwave",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/microwave.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_7",
          "address1": "ADDRESS_LINE1_7",
          "address2": null,
          "city": "ADDRESS_CITY_7",
          "add_state": "ADDRESS_STATE_7",
          "zip": "ADDRESS_ZIP_7",
          "state": "active",
          "address_name": "ADDRESS_NAME_7"
        }
      },
      {
        "id": 35058,
        "address_id": "ADDRESS_ID_7",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-12-01",
        "description": null,
        "name": "Coffee Maker",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7106,
          "name": "Coffee Maker",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 516,
            "name": "Coffee Maker",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/coffee-pot (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_7",
          "address1": "ADDRESS_LINE1_7",
          "address2": null,
          "city": "ADDRESS_CITY_7",
          "add_state": "ADDRESS_STATE_7",
          "zip": "ADDRESS_ZIP_7",
          "state": "active",
          "address_name": "ADDRESS_NAME_7"
        }
      },
      {
        "id": 35059,
        "address_id": "ADDRESS_ID_7",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-12-01",
        "description": null,
        "name": "Air Conditioner",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7107,
          "name": "Air Conditioner",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 414,
            "name": "Air Conditioner",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/air-conditioner.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_7",
          "address1": "ADDRESS_LINE1_7",
          "address2": null,
          "city": "ADDRESS_CITY_7",
          "add_state": "ADDRESS_STATE_7",
          "zip": "ADDRESS_ZIP_7",
          "state": "active",
          "address_name": "ADDRESS_NAME_7"
        }
      },
      {
        "id": 35060,
        "address_id": "ADDRESS_ID_7",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-12-01",
        "description": null,
        "name": "Washer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7108,
          "name": "Washer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 432,
            "name": "Washer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/washing-machine.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_7",
          "address1": "ADDRESS_LINE1_7",
          "address2": null,
          "city": "ADDRESS_CITY_7",
          "add_state": "ADDRESS_STATE_7",
          "zip": "ADDRESS_ZIP_7",
          "state": "active",
          "address_name": "ADDRESS_NAME_7"
        }
      },
      {
        "id": 35061,
        "address_id": "ADDRESS_ID_7",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-12-01",
        "description": null,
        "name": "Dryer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7109,
          "name": "Dryer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 433,
            "name": "Dryer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/dryer.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_7",
          "address1": "ADDRESS_LINE1_7",
          "address2": null,
          "city": "ADDRESS_CITY_7",
          "add_state": "ADDRESS_STATE_7",
          "zip": "ADDRESS_ZIP_7",
          "state": "active",
          "address_name": "ADDRESS_NAME_7"
        }
      },
      {
        "id": 35062,
        "address_id": "ADDRESS_ID_7",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-12-01",
        "description": null,
        "name": "Dinner Plates",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7110,
          "name": "Dinner Plates",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 443,
            "name": "Dinner Plates",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/dish.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_7",
          "address1": "ADDRESS_LINE1_7",
          "address2": null,
          "city": "ADDRESS_CITY_7",
          "add_state": "ADDRESS_STATE_7",
          "zip": "ADDRESS_ZIP_7",
          "state": "active",
          "address_name": "ADDRESS_NAME_7"
        }
      },
      {
        "id": 35063,
        "address_id": "ADDRESS_ID_7",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-12-01",
        "description": null,
        "name": "Bowls",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7111,
          "name": "Bowls",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 444,
            "name": "Bowls",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/bowl.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_7",
          "address1": "ADDRESS_LINE1_7",
          "address2": null,
          "city": "ADDRESS_CITY_7",
          "add_state": "ADDRESS_STATE_7",
          "zip": "ADDRESS_ZIP_7",
          "state": "active",
          "address_name": "ADDRESS_NAME_7"
        }
      },
      {
        "id": 36049,
        "address_id": "ADDRESS_ID_7",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Toilet Paper",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1800,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7112,
          "name": "Toilet Paper",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 501,
            "name": "Toilet Paper",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/toilet-paper.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_7",
          "address1": "ADDRESS_LINE1_7",
          "address2": null,
          "city": "ADDRESS_CITY_7",
          "add_state": "ADDRESS_STATE_7",
          "zip": "ADDRESS_ZIP_7",
          "state": "active",
          "address_name": "ADDRESS_NAME_7"
        }
      },
      {
        "id": 36050,
        "address_id": "ADDRESS_ID_7",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Paper Towels",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1500,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7113,
          "name": "Paper Towels",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 502,
            "name": "Paper Towels",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/paper-towel.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_7",
          "address1": "ADDRESS_LINE1_7",
          "address2": null,
          "city": "ADDRESS_CITY_7",
          "add_state": "ADDRESS_STATE_7",
          "zip": "ADDRESS_ZIP_7",
          "state": "active",
          "address_name": "ADDRESS_NAME_7"
        }
      },
      {
        "id": 36051,
        "address_id": "ADDRESS_ID_7",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Hand Soap",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 700,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7114,
          "name": "Hand Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 503,
            "name": "Hand Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_7",
          "address1": "ADDRESS_LINE1_7",
          "address2": null,
          "city": "ADDRESS_CITY_7",
          "add_state": "ADDRESS_STATE_7",
          "zip": "ADDRESS_ZIP_7",
          "state": "active",
          "address_name": "ADDRESS_NAME_7"
        }
      },
      {
        "id": 36052,
        "address_id": "ADDRESS_ID_7",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Dish Soap",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 600,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7115,
          "name": "Dish Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 506,
            "name": "Dish Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_7",
          "address1": "ADDRESS_LINE1_7",
          "address2": null,
          "city": "ADDRESS_CITY_7",
          "add_state": "ADDRESS_STATE_7",
          "zip": "ADDRESS_ZIP_7",
          "state": "active",
          "address_name": "ADDRESS_NAME_7"
        }
      },
      {
        "id": 36053,
        "address_id": "ADDRESS_ID_7",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Trash Bags",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1100,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7116,
          "name": "Trash Bags",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 511,
            "name": "Trash Bags",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/trash_service.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_7",
          "address1": "ADDRESS_LINE1_7",
          "address2": null,
          "city": "ADDRESS_CITY_7",
          "add_state": "ADDRESS_STATE_7",
          "zip": "ADDRESS_ZIP_7",
          "state": "active",
          "address_name": "ADDRESS_NAME_7"
        }
      },
      {
        "id": 36054,
        "address_id": "ADDRESS_ID_7",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Coffee",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 2400,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7117,
          "name": "Coffee",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 504,
            "name": "Coffee",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hot-drink.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_7",
          "address1": "ADDRESS_LINE1_7",
          "address2": null,
          "city": "ADDRESS_CITY_7",
          "add_state": "ADDRESS_STATE_7",
          "zip": "ADDRESS_ZIP_7",
          "state": "active",
          "address_name": "ADDRESS_NAME_7"
        }
      },
      {
        "id": 36055,
        "address_id": "ADDRESS_ID_7",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Shampoo",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 900,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7118,
          "name": "Shampoo",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 508,
            "name": "Shampoo",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_7",
          "address1": "ADDRESS_LINE1_7",
          "address2": null,
          "city": "ADDRESS_CITY_7",
          "add_state": "ADDRESS_STATE_7",
          "zip": "ADDRESS_ZIP_7",
          "state": "active",
          "address_name": "ADDRESS_NAME_7"
        }
      },
      {
        "id": 36056,
        "address_id": "ADDRESS_ID_7",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Conditioner",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 900,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7119,
          "name": "Conditioner",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 515,
            "name": "Conditioner",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_7",
          "address1": "ADDRESS_LINE1_7",
          "address2": null,
          "city": "ADDRESS_CITY_7",
          "add_state": "ADDRESS_STATE_7",
          "zip": "ADDRESS_ZIP_7",
          "state": "active",
          "address_name": "ADDRESS_NAME_7"
        }
      },
      {
        "id": 35064,
        "address_id": "ADDRESS_ID_8",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-04-05",
        "description": null,
        "name": "Smart TV",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7120,
          "name": "Smart TV",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 248,
            "name": "Smart TV",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_8",
          "address1": "ADDRESS_LINE1_8",
          "address2": null,
          "city": "ADDRESS_CITY_8",
          "add_state": "ADDRESS_STATE_8",
          "zip": "ADDRESS_ZIP_8",
          "state": "active",
          "address_name": "ADDRESS_NAME_8"
        }
      },
      {
        "id": 35065,
        "address_id": "ADDRESS_ID_8",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-04-05",
        "description": null,
        "name": "Refrigerator",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7121,
          "name": "Refrigerator",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 413,
            "name": "Refrigerator",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/refrigerator (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_8",
          "address1": "ADDRESS_LINE1_8",
          "address2": null,
          "city": "ADDRESS_CITY_8",
          "add_state": "ADDRESS_STATE_8",
          "zip": "ADDRESS_ZIP_8",
          "state": "active",
          "address_name": "ADDRESS_NAME_8"
        }
      },
      {
        "id": 35066,
        "address_id": "ADDRESS_ID_8",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-04-05",
        "description": null,
        "name": "Microwave",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7122,
          "name": "Microwave",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 428,
            "name": "Microwave",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/microwave.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_8",
          "address1": "ADDRESS_LINE1_8",
          "address2": null,
          "city": "ADDRESS_CITY_8",
          "add_state": "ADDRESS_STATE_8",
          "zip": "ADDRESS_ZIP_8",
          "state": "active",
          "address_name": "ADDRESS_NAME_8"
        }
      },
      {
        "id": 35067,
        "address_id": "ADDRESS_ID_8",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-04-05",
        "description": null,
        "name": "Coffee Maker",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7123,
          "name": "Coffee Maker",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 516,
            "name": "Coffee Maker",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/coffee-pot (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_8",
          "address1": "ADDRESS_LINE1_8",
          "address2": null,
          "city": "ADDRESS_CITY_8",
          "add_state": "ADDRESS_STATE_8",
          "zip": "ADDRESS_ZIP_8",
          "state": "active",
          "address_name": "ADDRESS_NAME_8"
        }
      },
      {
        "id": 35068,
        "address_id": "ADDRESS_ID_8",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-04-05",
        "description": null,
        "name": "Air Conditioner",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7124,
          "name": "Air Conditioner",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 414,
            "name": "Air Conditioner",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/air-conditioner.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_8",
          "address1": "ADDRESS_LINE1_8",
          "address2": null,
          "city": "ADDRESS_CITY_8",
          "add_state": "ADDRESS_STATE_8",
          "zip": "ADDRESS_ZIP_8",
          "state": "active",
          "address_name": "ADDRESS_NAME_8"
        }
      },
      {
        "id": 35069,
        "address_id": "ADDRESS_ID_8",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-04-05",
        "description": null,
        "name": "Washer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7125,
          "name": "Washer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 432,
            "name": "Washer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/washing-machine.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_8",
          "address1": "ADDRESS_LINE1_8",
          "address2": null,
          "city": "ADDRESS_CITY_8",
          "add_state": "ADDRESS_STATE_8",
          "zip": "ADDRESS_ZIP_8",
          "state": "active",
          "address_name": "ADDRESS_NAME_8"
        }
      },
      {
        "id": 35070,
        "address_id": "ADDRESS_ID_8",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-04-05",
        "description": null,
        "name": "Dryer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7126,
          "name": "Dryer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 433,
            "name": "Dryer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/dryer.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_8",
          "address1": "ADDRESS_LINE1_8",
          "address2": null,
          "city": "ADDRESS_CITY_8",
          "add_state": "ADDRESS_STATE_8",
          "zip": "ADDRESS_ZIP_8",
          "state": "active",
          "address_name": "ADDRESS_NAME_8"
        }
      },
      {
        "id": 35071,
        "address_id": "ADDRESS_ID_8",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-04-05",
        "description": null,
        "name": "Drinking Glasses",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7127,
          "name": "Drinking Glasses",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 416,
            "name": "Drinking Glasses",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/glass-of-water.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_8",
          "address1": "ADDRESS_LINE1_8",
          "address2": null,
          "city": "ADDRESS_CITY_8",
          "add_state": "ADDRESS_STATE_8",
          "zip": "ADDRESS_ZIP_8",
          "state": "active",
          "address_name": "ADDRESS_NAME_8"
        }
      },
      {
        "id": 35072,
        "address_id": "ADDRESS_ID_8",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-04-05",
        "description": null,
        "name": "Coffee Mugs",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7128,
          "name": "Coffee Mugs",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 417,
            "name": "Coffee Mugs",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hot-drink.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_8",
          "address1": "ADDRESS_LINE1_8",
          "address2": null,
          "city": "ADDRESS_CITY_8",
          "add_state": "ADDRESS_STATE_8",
          "zip": "ADDRESS_ZIP_8",
          "state": "active",
          "address_name": "ADDRESS_NAME_8"
        }
      },
      {
        "id": 36057,
        "address_id": "ADDRESS_ID_8",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Toilet Paper",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1800,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7129,
          "name": "Toilet Paper",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 501,
            "name": "Toilet Paper",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/toilet-paper.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_8",
          "address1": "ADDRESS_LINE1_8",
          "address2": null,
          "city": "ADDRESS_CITY_8",
          "add_state": "ADDRESS_STATE_8",
          "zip": "ADDRESS_ZIP_8",
          "state": "active",
          "address_name": "ADDRESS_NAME_8"
        }
      },
      {
        "id": 36058,
        "address_id": "ADDRESS_ID_8",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Paper Towels",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 1500,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7130,
          "name": "Paper Towels",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 502,
            "name": "Paper Towels",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/paper-towel.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_8",
          "address1": "ADDRESS_LINE1_8",
          "address2": null,
          "city": "ADDRESS_CITY_8",
          "add_state": "ADDRESS_STATE_8",
          "zip": "ADDRESS_ZIP_8",
          "state": "active",
          "address_name": "ADDRESS_NAME_8"
        }
      },
      {
        "id": 36059,
        "address_id": "ADDRESS_ID_8",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Hand Soap",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 700,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7131,
          "name": "Hand Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 503,
            "name": "Hand Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_8",
          "address1": "ADDRESS_LINE1_8",
          "address2": null,
          "city": "ADDRESS_CITY_8",
          "add_state": "ADDRESS_STATE_8",
          "zip": "ADDRESS_ZIP_8",
          "state": "active",
          "address_name": "ADDRESS_NAME_8"
        }
      },
      {
        "id": 36060,
        "address_id": "ADDRESS_ID_8",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Dish Soap",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 600,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7132,
          "name": "Dish Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 506,
            "name": "Dish Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_8",
          "address1": "ADDRESS_LINE1_8",
          "address2": null,
          "city": "ADDRESS_CITY_8",
          "add_state": "ADDRESS_STATE_8",
          "zip": "ADDRESS_ZIP_8",
          "state": "active",
          "address_name": "ADDRESS_NAME_8"
        }
      },
      {
        "id": 36061,
        "address_id": "ADDRESS_ID_8",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Trash Bags",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 1100,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7133,
          "name": "Trash Bags",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 511,
            "name": "Trash Bags",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/trash_service.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_8",
          "address1": "ADDRESS_LINE1_8",
          "address2": null,
          "city": "ADDRESS_CITY_8",
          "add_state": "ADDRESS_STATE_8",
          "zip": "ADDRESS_ZIP_8",
          "state": "active",
          "address_name": "ADDRESS_NAME_8"
        }
      },
      {
        "id": 36062,
        "address_id": "ADDRESS_ID_8",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Coffee",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 2400,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7134,
          "name": "Coffee",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 504,
            "name": "Coffee",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hot-drink.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_8",
          "address1": "ADDRESS_LINE1_8",
          "address2": null,
          "city": "ADDRESS_CITY_8",
          "add_state": "ADDRESS_STATE_8",
          "zip": "ADDRESS_ZIP_8",
          "state": "active",
          "address_name": "ADDRESS_NAME_8"
        }
      },
      {
        "id": 36063,
        "address_id": "ADDRESS_ID_8",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Body Wash",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 850,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7135,
          "name": "Body Wash",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 514,
            "name": "Body Wash",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_8",
          "address1": "ADDRESS_LINE1_8",
          "address2": null,
          "city": "ADDRESS_CITY_8",
          "add_state": "ADDRESS_STATE_8",
          "zip": "ADDRESS_ZIP_8",
          "state": "active",
          "address_name": "ADDRESS_NAME_8"
        }
      },
      {
        "id": 36064,
        "address_id": "ADDRESS_ID_8",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Laundry Detergent",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 1600,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7136,
          "name": "Laundry Detergent",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 505,
            "name": "Laundry Detergent",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/laundry.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_8",
          "address1": "ADDRESS_LINE1_8",
          "address2": null,
          "city": "ADDRESS_CITY_8",
          "add_state": "ADDRESS_STATE_8",
          "zip": "ADDRESS_ZIP_8",
          "state": "active",
          "address_name": "ADDRESS_NAME_8"
        }
      },
      {
        "id": 35073,
        "address_id": "ADDRESS_ID_9",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-03-30",
        "description": null,
        "name": "Smart TV",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7137,
          "name": "Smart TV",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 248,
            "name": "Smart TV",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_9",
          "address1": "ADDRESS_LINE1_9",
          "address2": null,
          "city": "ADDRESS_CITY_9",
          "add_state": "ADDRESS_STATE_9",
          "zip": "ADDRESS_ZIP_9",
          "state": "active",
          "address_name": "ADDRESS_NAME_9"
        }
      },
      {
        "id": 35074,
        "address_id": "ADDRESS_ID_9",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-03-30",
        "description": null,
        "name": "Refrigerator",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7138,
          "name": "Refrigerator",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 413,
            "name": "Refrigerator",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/refrigerator (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_9",
          "address1": "ADDRESS_LINE1_9",
          "address2": null,
          "city": "ADDRESS_CITY_9",
          "add_state": "ADDRESS_STATE_9",
          "zip": "ADDRESS_ZIP_9",
          "state": "active",
          "address_name": "ADDRESS_NAME_9"
        }
      },
      {
        "id": 35075,
        "address_id": "ADDRESS_ID_9",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-03-30",
        "description": null,
        "name": "Microwave",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7139,
          "name": "Microwave",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 428,
            "name": "Microwave",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/microwave.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_9",
          "address1": "ADDRESS_LINE1_9",
          "address2": null,
          "city": "ADDRESS_CITY_9",
          "add_state": "ADDRESS_STATE_9",
          "zip": "ADDRESS_ZIP_9",
          "state": "active",
          "address_name": "ADDRESS_NAME_9"
        }
      },
      {
        "id": 35076,
        "address_id": "ADDRESS_ID_9",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-03-30",
        "description": null,
        "name": "Coffee Maker",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7140,
          "name": "Coffee Maker",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 516,
            "name": "Coffee Maker",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/coffee-pot (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_9",
          "address1": "ADDRESS_LINE1_9",
          "address2": null,
          "city": "ADDRESS_CITY_9",
          "add_state": "ADDRESS_STATE_9",
          "zip": "ADDRESS_ZIP_9",
          "state": "active",
          "address_name": "ADDRESS_NAME_9"
        }
      },
      {
        "id": 35077,
        "address_id": "ADDRESS_ID_9",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-03-30",
        "description": null,
        "name": "Air Conditioner",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7141,
          "name": "Air Conditioner",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 414,
            "name": "Air Conditioner",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/air-conditioner.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_9",
          "address1": "ADDRESS_LINE1_9",
          "address2": null,
          "city": "ADDRESS_CITY_9",
          "add_state": "ADDRESS_STATE_9",
          "zip": "ADDRESS_ZIP_9",
          "state": "active",
          "address_name": "ADDRESS_NAME_9"
        }
      },
      {
        "id": 35078,
        "address_id": "ADDRESS_ID_9",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-03-30",
        "description": null,
        "name": "Washer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7142,
          "name": "Washer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 432,
            "name": "Washer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/washing-machine.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_9",
          "address1": "ADDRESS_LINE1_9",
          "address2": null,
          "city": "ADDRESS_CITY_9",
          "add_state": "ADDRESS_STATE_9",
          "zip": "ADDRESS_ZIP_9",
          "state": "active",
          "address_name": "ADDRESS_NAME_9"
        }
      },
      {
        "id": 35079,
        "address_id": "ADDRESS_ID_9",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-03-30",
        "description": null,
        "name": "Dryer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7143,
          "name": "Dryer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 433,
            "name": "Dryer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/dryer.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_9",
          "address1": "ADDRESS_LINE1_9",
          "address2": null,
          "city": "ADDRESS_CITY_9",
          "add_state": "ADDRESS_STATE_9",
          "zip": "ADDRESS_ZIP_9",
          "state": "active",
          "address_name": "ADDRESS_NAME_9"
        }
      },
      {
        "id": 35080,
        "address_id": "ADDRESS_ID_9",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-03-30",
        "description": null,
        "name": "Flatware Set",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7144,
          "name": "Flatware Set",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 445,
            "name": "Flatware Set",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/fork.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_9",
          "address1": "ADDRESS_LINE1_9",
          "address2": null,
          "city": "ADDRESS_CITY_9",
          "add_state": "ADDRESS_STATE_9",
          "zip": "ADDRESS_ZIP_9",
          "state": "active",
          "address_name": "ADDRESS_NAME_9"
        }
      },
      {
        "id": 35081,
        "address_id": "ADDRESS_ID_9",
        "consumable": false,
        "state": "active",
        "installation_date": "2023-03-30",
        "description": null,
        "name": "Knife Block",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7145,
          "name": "Knife Block",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 446,
            "name": "Knife Block",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/knife.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_9",
          "address1": "ADDRESS_LINE1_9",
          "address2": null,
          "city": "ADDRESS_CITY_9",
          "add_state": "ADDRESS_STATE_9",
          "zip": "ADDRESS_ZIP_9",
          "state": "active",
          "address_name": "ADDRESS_NAME_9"
        }
      },
      {
        "id": 36065,
        "address_id": "ADDRESS_ID_9",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Toilet Paper",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 1800,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7146,
          "name": "Toilet Paper",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 501,
            "name": "Toilet Paper",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/toilet-paper.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_9",
          "address1": "ADDRESS_LINE1_9",
          "address2": null,
          "city": "ADDRESS_CITY_9",
          "add_state": "ADDRESS_STATE_9",
          "zip": "ADDRESS_ZIP_9",
          "state": "active",
          "address_name": "ADDRESS_NAME_9"
        }
      },
      {
        "id": 36066,
        "address_id": "ADDRESS_ID_9",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Paper Towels",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1500,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7147,
          "name": "Paper Towels",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 502,
            "name": "Paper Towels",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/paper-towel.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_9",
          "address1": "ADDRESS_LINE1_9",
          "address2": null,
          "city": "ADDRESS_CITY_9",
          "add_state": "ADDRESS_STATE_9",
          "zip": "ADDRESS_ZIP_9",
          "state": "active",
          "address_name": "ADDRESS_NAME_9"
        }
      },
      {
        "id": 36067,
        "address_id": "ADDRESS_ID_9",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Hand Soap",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 700,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7148,
          "name": "Hand Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 503,
            "name": "Hand Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_9",
          "address1": "ADDRESS_LINE1_9",
          "address2": null,
          "city": "ADDRESS_CITY_9",
          "add_state": "ADDRESS_STATE_9",
          "zip": "ADDRESS_ZIP_9",
          "state": "active",
          "address_name": "ADDRESS_NAME_9"
        }
      },
      {
        "id": 36068,
        "address_id": "ADDRESS_ID_9",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Dish Soap",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 600,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7149,
          "name": "Dish Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 506,
            "name": "Dish Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_9",
          "address1": "ADDRESS_LINE1_9",
          "address2": null,
          "city": "ADDRESS_CITY_9",
          "add_state": "ADDRESS_STATE_9",
          "zip": "ADDRESS_ZIP_9",
          "state": "active",
          "address_name": "ADDRESS_NAME_9"
        }
      },
      {
        "id": 36069,
        "address_id": "ADDRESS_ID_9",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Trash Bags",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1100,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7150,
          "name": "Trash Bags",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 511,
            "name": "Trash Bags",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/trash_service.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_9",
          "address1": "ADDRESS_LINE1_9",
          "address2": null,
          "city": "ADDRESS_CITY_9",
          "add_state": "ADDRESS_STATE_9",
          "zip": "ADDRESS_ZIP_9",
          "state": "active",
          "address_name": "ADDRESS_NAME_9"
        }
      },
      {
        "id": 36070,
        "address_id": "ADDRESS_ID_9",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Coffee",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 2400,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7151,
          "name": "Coffee",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 504,
            "name": "Coffee",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hot-drink.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_9",
          "address1": "ADDRESS_LINE1_9",
          "address2": null,
          "city": "ADDRESS_CITY_9",
          "add_state": "ADDRESS_STATE_9",
          "zip": "ADDRESS_ZIP_9",
          "state": "active",
          "address_name": "ADDRESS_NAME_9"
        }
      },
      {
        "id": 36071,
        "address_id": "ADDRESS_ID_9",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "All-Purpose Cleaner",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 800,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7152,
          "name": "All-Purpose Cleaner",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 507,
            "name": "All-Purpose Cleaner",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/cleaner.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_9",
          "address1": "ADDRESS_LINE1_9",
          "address2": null,
          "city": "ADDRESS_CITY_9",
          "add_state": "ADDRESS_STATE_9",
          "zip": "ADDRESS_ZIP_9",
          "state": "active",
          "address_name": "ADDRESS_NAME_9"
        }
      },
      {
        "id": 36072,
        "address_id": "ADDRESS_ID_9",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Glass Cleaner",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 650,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7153,
          "name": "Glass Cleaner",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 512,
            "name": "Glass Cleaner",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/cleaner.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_9",
          "address1": "ADDRESS_LINE1_9",
          "address2": null,
          "city": "ADDRESS_CITY_9",
          "add_state": "ADDRESS_STATE_9",
          "zip": "ADDRESS_ZIP_9",
          "state": "active",
          "address_name": "ADDRESS_NAME_9"
        }
      },
      {
        "id": 35082,
        "address_id": "ADDRESS_ID_10",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-06-01",
        "description": null,
        "name": "Smart TV",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7154,
          "name": "Smart TV",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 248,
            "name": "Smart TV",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_10",
          "address1": "ADDRESS_LINE1_10",
          "address2": null,
          "city": "ADDRESS_CITY_10",
          "add_state": "ADDRESS_STATE_10",
          "zip": "ADDRESS_ZIP_10",
          "state": "active",
          "address_name": "ADDRESS_NAME_10"
        }
      },
      {
        "id": 35083,
        "address_id": "ADDRESS_ID_10",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-06-01",
        "description": null,
        "name": "Refrigerator",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7155,
          "name": "Refrigerator",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 413,
            "name": "Refrigerator",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/refrigerator (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_10",
          "address1": "ADDRESS_LINE1_10",
          "address2": null,
          "city": "ADDRESS_CITY_10",
          "add_state": "ADDRESS_STATE_10",
          "zip": "ADDRESS_ZIP_10",
          "state": "active",
          "address_name": "ADDRESS_NAME_10"
        }
      },
      {
        "id": 35084,
        "address_id": "ADDRESS_ID_10",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-06-01",
        "description": null,
        "name": "Microwave",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7156,
          "name": "Microwave",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 428,
            "name": "Microwave",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/microwave.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_10",
          "address1": "ADDRESS_LINE1_10",
          "address2": null,
          "city": "ADDRESS_CITY_10",
          "add_state": "ADDRESS_STATE_10",
          "zip": "ADDRESS_ZIP_10",
          "state": "active",
          "address_name": "ADDRESS_NAME_10"
        }
      },
      {
        "id": 35085,
        "address_id": "ADDRESS_ID_10",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-06-01",
        "description": null,
        "name": "Coffee Maker",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7157,
          "name": "Coffee Maker",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 516,
            "name": "Coffee Maker",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/coffee-pot (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_10",
          "address1": "ADDRESS_LINE1_10",
          "address2": null,
          "city": "ADDRESS_CITY_10",
          "add_state": "ADDRESS_STATE_10",
          "zip": "ADDRESS_ZIP_10",
          "state": "active",
          "address_name": "ADDRESS_NAME_10"
        }
      },
      {
        "id": 35086,
        "address_id": "ADDRESS_ID_10",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-06-01",
        "description": null,
        "name": "Air Conditioner",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7158,
          "name": "Air Conditioner",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 414,
            "name": "Air Conditioner",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/air-conditioner.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_10",
          "address1": "ADDRESS_LINE1_10",
          "address2": null,
          "city": "ADDRESS_CITY_10",
          "add_state": "ADDRESS_STATE_10",
          "zip": "ADDRESS_ZIP_10",
          "state": "active",
          "address_name": "ADDRESS_NAME_10"
        }
      },
      {
        "id": 35087,
        "address_id": "ADDRESS_ID_10",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-06-01",
        "description": null,
        "name": "Washer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7159,
          "name": "Washer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 432,
            "name": "Washer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/washing-machine.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_10",
          "address1": "ADDRESS_LINE1_10",
          "address2": null,
          "city": "ADDRESS_CITY_10",
          "add_state": "ADDRESS_STATE_10",
          "zip": "ADDRESS_ZIP_10",
          "state": "active",
          "address_name": "ADDRESS_NAME_10"
        }
      },
      {
        "id": 35088,
        "address_id": "ADDRESS_ID_10",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-06-01",
        "description": null,
        "name": "Dryer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7160,
          "name": "Dryer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 433,
            "name": "Dryer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/dryer.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_10",
          "address1": "ADDRESS_LINE1_10",
          "address2": null,
          "city": "ADDRESS_CITY_10",
          "add_state": "ADDRESS_STATE_10",
          "zip": "ADDRESS_ZIP_10",
          "state": "active",
          "address_name": "ADDRESS_NAME_10"
        }
      },
      {
        "id": 35089,
        "address_id": "ADDRESS_ID_10",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-06-01",
        "description": null,
        "name": "Beach Umbrella",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7161,
          "name": "Beach Umbrella",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 447,
            "name": "Beach Umbrella",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/umbrella.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_10",
          "address1": "ADDRESS_LINE1_10",
          "address2": null,
          "city": "ADDRESS_CITY_10",
          "add_state": "ADDRESS_STATE_10",
          "zip": "ADDRESS_ZIP_10",
          "state": "active",
          "address_name": "ADDRESS_NAME_10"
        }
      },
      {
        "id": 35090,
        "address_id": "ADDRESS_ID_10",
        "consumable": false,
        "state": "active",
        "installation_date": "2022-06-01",
        "description": null,
        "name": "Freezer",
        "min_quantity": 1,
        "current_quantity": 1,
        "max_quantity": null,
        "low_quantity_alert": false,
        "item_cost": null,
        "photo_url": null,
        "model": {
          "id": 7162,
          "name": "Freezer",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 437,
            "name": "Freezer",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/freezer.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_10",
          "address1": "ADDRESS_LINE1_10",
          "address2": null,
          "city": "ADDRESS_CITY_10",
          "add_state": "ADDRESS_STATE_10",
          "zip": "ADDRESS_ZIP_10",
          "state": "active",
          "address_name": "ADDRESS_NAME_10"
        }
      },
      {
        "id": 36073,
        "address_id": "ADDRESS_ID_10",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Toilet Paper",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1800,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7163,
          "name": "Toilet Paper",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 501,
            "name": "Toilet Paper",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/toilet-paper.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_10",
          "address1": "ADDRESS_LINE1_10",
          "address2": null,
          "city": "ADDRESS_CITY_10",
          "add_state": "ADDRESS_STATE_10",
          "zip": "ADDRESS_ZIP_10",
          "state": "active",
          "address_name": "ADDRESS_NAME_10"
        }
      },
      {
        "id": 36074,
        "address_id": "ADDRESS_ID_10",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Paper Towels",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1500,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7164,
          "name": "Paper Towels",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 502,
            "name": "Paper Towels",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/paper-towel.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_10",
          "address1": "ADDRESS_LINE1_10",
          "address2": null,
          "city": "ADDRESS_CITY_10",
          "add_state": "ADDRESS_STATE_10",
          "zip": "ADDRESS_ZIP_10",
          "state": "active",
          "address_name": "ADDRESS_NAME_10"
        }
      },
      {
        "id": 36075,
        "address_id": "ADDRESS_ID_10",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Hand Soap",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 700,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7165,
          "name": "Hand Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 503,
            "name": "Hand Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_10",
          "address1": "ADDRESS_LINE1_10",
          "address2": null,
          "city": "ADDRESS_CITY_10",
          "add_state": "ADDRESS_STATE_10",
          "zip": "ADDRESS_ZIP_10",
          "state": "active",
          "address_name": "ADDRESS_NAME_10"
        }
      },
      {
        "id": 36076,
        "address_id": "ADDRESS_ID_10",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Dish Soap",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 600,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7166,
          "name": "Dish Soap",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 506,
            "name": "Dish Soap",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hand-soap.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_10",
          "address1": "ADDRESS_LINE1_10",
          "address2": null,
          "city": "ADDRESS_CITY_10",
          "add_state": "ADDRESS_STATE_10",
          "zip": "ADDRESS_ZIP_10",
          "state": "active",
          "address_name": "ADDRESS_NAME_10"
        }
      },
      {
        "id": 36077,
        "address_id": "ADDRESS_ID_10",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Trash Bags",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1100,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7167,
          "name": "Trash Bags",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 511,
            "name": "Trash Bags",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/trash_service.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_10",
          "address1": "ADDRESS_LINE1_10",
          "address2": null,
          "city": "ADDRESS_CITY_10",
          "add_state": "ADDRESS_STATE_10",
          "zip": "ADDRESS_ZIP_10",
          "state": "active",
          "address_name": "ADDRESS_NAME_10"
        }
      },
      {
        "id": 36078,
        "address_id": "ADDRESS_ID_10",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Coffee",
        "min_quantity": 6,
        "current_quantity": 2,
        "max_quantity": 24,
        "low_quantity_alert": true,
        "item_cost": 2400,
        "where_to_order": "Costco",
        "photo_url": null,
        "model": {
          "id": 7168,
          "name": "Coffee",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 504,
            "name": "Coffee",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hot-drink.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_10",
          "address1": "ADDRESS_LINE1_10",
          "address2": null,
          "city": "ADDRESS_CITY_10",
          "add_state": "ADDRESS_STATE_10",
          "zip": "ADDRESS_ZIP_10",
          "state": "active",
          "address_name": "ADDRESS_NAME_10"
        }
      },
      {
        "id": 36079,
        "address_id": "ADDRESS_ID_10",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Disinfecting Wipes",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 750,
        "where_to_order": "Target",
        "photo_url": null,
        "model": {
          "id": 7169,
          "name": "Disinfecting Wipes",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 509,
            "name": "Disinfecting Wipes",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/wipes.svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_10",
          "address1": "ADDRESS_LINE1_10",
          "address2": null,
          "city": "ADDRESS_CITY_10",
          "add_state": "ADDRESS_STATE_10",
          "zip": "ADDRESS_ZIP_10",
          "state": "active",
          "address_name": "ADDRESS_NAME_10"
        }
      },
      {
        "id": 36080,
        "address_id": "ADDRESS_ID_10",
        "consumable": true,
        "state": "active",
        "installation_date": null,
        "description": null,
        "name": "Light Bulbs",
        "min_quantity": 6,
        "current_quantity": 8,
        "max_quantity": 24,
        "low_quantity_alert": false,
        "item_cost": 1400,
        "where_to_order": "Amazon",
        "photo_url": null,
        "model": {
          "id": 7170,
          "name": "Light Bulbs",
          "model": null,
          "kind": "generic",
          "category": {
            "id": 744,
            "name": "Light Bulbs",
            "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/light-bulb (1).svg",
            "room_categories": []
          }
        },
        "address": {
          "id": "ADDRESS_ID_10",
          "address1": "ADDRESS_LINE1_10",
          "address2": null,
          "city": "ADDRESS_CITY_10",
          "add_state": "ADDRESS_STATE_10",
          "zip": "ADDRESS_ZIP_10",
          "state": "active",
          "address_name": "ADDRESS_NAME_10"
        }
      }
    ]
  }
}